import React from 'react';
import { motion } from 'framer-motion';
import { ClockIcon } from 'lucide-react';
export function OpeningHookSection() {
  return <section className="py-20 px-4 md:px-8 bg-nightBlue relative" data-id="element-116">
      <div className="max-w-3xl mx-auto" data-id="element-117">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="bg-nightBlueLighter/50 border border-white/5 rounded-3xl p-8 md:p-12 relative overflow-hidden" data-id="element-118">
          <div className="absolute top-0 right-0 p-8 opacity-10" data-id="element-119">
            <ClockIcon className="w-32 h-32 text-warmWhite" data-id="element-120" />
          </div>

          <p className="font-lato text-lg md:text-xl text-warmWhite leading-relaxed mb-6 relative z-10" data-id="element-121">
            <span className="font-montserrat font-bold text-gold text-2xl md:text-3xl block mb-4" data-id="element-122">
              Son las 3:14 de la mañana.
            </span>
            Estás mirando el techo, escuchando el silencio de la casa y
            sintiendo ese "run-run" en el pecho. Sabes que si no te duermes ya,
            mañana será otro día perdido entre neblina mental y mal humor.
          </p>

          <p className="font-lato text-lg md:text-xl text-warmWhite leading-relaxed relative z-10" data-id="element-123">
            Lo peor no es estar despierto; lo peor es sentir que tu cuerpo te ha
            traicionado y que, a tu edad, "esto es lo que toca". Pero tengo una
            noticia para ti:{' '}
            <span className="text-gold font-bold" data-id="element-124">
              tu cuerpo no ha olvidado cómo dormir
            </span>
            , simplemente está recibiendo las instrucciones equivocadas.
          </p>
        </motion.div>
      </div>
    </section>;
}